var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProgressZero = function SvgProgressZero(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.5 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0 1c5.523 0 10-4.477 10-10s-4.477-10-10-10S.5 4.477.5 10s4.477 10 10 10M9.875 5v6.875h1.25V5zm.104 8.908a.938.938 0 1 1 1.042 1.56.938.938 0 0 1-1.042-1.56",
    clipRule: "evenodd",
    opacity: 0.3
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProgressZero);
export { ForwardRef as ReactComponent };